import { alertConstant } from "../constants/AlertConstant";

export const alertAction = {
  showErrorMessage,
  showNetworkAPIErrorMessage,
  resetErrorMessage,
};

function showErrorMessage(errorMessage) {
  return {
    type: alertConstant.SHOW_ERROR_MESSAGE,
    errorMessage,
  };
}

function showNetworkAPIErrorMessage(errorMessage, logoutFunction) {
  return {
    type: alertConstant.SHOW_NETWORK_ERROR_API_MESSAGE,
    errorMessage,
    logoutFunction,
  };
}

function resetErrorMessage() {
  return { type: alertConstant.RESET_ERROR_MESSAGE };
}
